import Button from '@/common/components/Button';
import { ShowHeader } from '@/common/components/ShowHeader';
import { useMineCompany } from '@/features/company/hooks/useMineCompany';
import { Link } from 'react-router-dom';
import DashboardsComingSoon from '../../components/Dashboard/DashboardsComingSoon';

const Show = () => {
  const {
    data: company,
  } = useMineCompany()

  return (
    <div className="inner-screen gap-6">
      <ShowHeader
        logoUrl={company?.matrix_branch?.general_information.company_logo?.url}
        title={company?.matrix_branch?.general_information.fantasy_name}
        buttons={
          <Link to="/company/mine">
            <Button variant="outline-disabled">
              Ver perfil
            </Button>
          </Link>
        }
        className="mb-0"
      />

      <DashboardsComingSoon />
    </div>
  )
}

export default Show
